<template>
  <div>
    <div
      class="image-uploader"
      :class="{ smallImageUploader: small, uploaded: url }"
    >
      <v-dropzone
        :ref="dropZoneId"
        :id="dropZoneId"
        class="image-uploader-style"
        :options="dropzoneOptions"
        @vdropzone-removed-file="vDzRemove"
        @vdropzone-max-files-exceeded="vDzMaxFilesExceeded"
        @vdropzone-max-files-reached="vDzMaxFilesReached"
        @vdropzone-file-added-manually="vDzMounted"
        @vdropzone-files-added="uploadFiles"
      >
      </v-dropzone>
      <div class="pdf-preview" v-if="fileType === 'pdf' && fileThumb">
        <img :src="fileThumb" alt="" />
      </div>
      <div
        v-if="this.url && !loading"
        :class="`open-image-dialog-${dropZoneId}`"
        class="replace-image"
      >
        <span class="d-block"></span>
      </div>
      <div
        v-if="!this.url && !loading"
        :class="`open-image-dialog-${dropZoneId}`"
        class="upload-image"
      >
        <span class="d-block primary--text">{{ dragPlaceholder }}</span>
      </div>
      <div class="image-loader" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
          id="loading"
        ></v-progress-circular>
      </div>
      <div class="image-removal" v-if="canRemove && url" @click="removeFile">
        <span><v-icon class="red--text">delete_outline</v-icon></span>
      </div>
    </div>
    <span v-if="!this.url && validation" class="error--text"
      >File Is Required</span
    >
  </div>
</template>

<script>
import generatePdfThumbnails from "pdf-thumbnails-generator";
import vDropzone from "vue2-dropzone";
import fileValidationMixin from "../../../../../mixins/fileValidationMixin";
export default {
  name: "file-uploader",
  mixins: [fileValidationMixin],
  props: {
    uploadUrl: {
      type: String,
      default: "/file/upload",
    },
    uploadInstance: {
      type: [Object, Function],
      default: null,
    },
    url: {
      type: String,
      default: () => {
        return "";
      },
    },
    small: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    validation: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    dragPlaceholder: {
      type: String,
      default: "Drag and drop ﬁles here or Upload",
    },
    cropFirst: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "botter-image-icon",
    },
    type: {
      type: String,
      default: "image",
    },
    canRemove: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    maxFiles: {
      type: [String, Number],
      default: "2",
    },
    maxFilesize: {
      type: [String, Number],
      default: "10",
    },
  },
  components: {
    vDropzone,
  },
  data() {
    return {
      dropZoneId: `vueDropzone${this._uid}`,
      cropDialog: false,
      cropStep: null,
      aspectRatio: 1,
      cropSaveLoading: false,
      imageToBeCropped: null,
      loading: false,
      dropzoneOptions: {
        url: "#",
        thumbnailWidth: 300,
        maxFilesize: +this.maxFilesize,
        maxFiles: +this.maxFiles,
        addRemoveLinks: true,
        autoProcessQueue: false,
        acceptedFiles: `${this.types ? this.types : `${this.type}/*`}`,
        previewTemplate: this.getTemplate(),
        dictDefaultMessage: `<span class="${this.icon} primary-text text-lg-2" />`,
      },
      fileType: "",
      fileSize: "",
      fileThumb: "",
      fileNumOfPages: 0,
    };
  },
  mounted() {
    this.loadImg();
    // this.fileType = this.url.split(".").pop()
    //   ? this.url.split(".").pop()
    //   : "undefined";
    // if (this.fileType === "pdf") {
    //   this.getFileThumb();
    // }
    // let image = document.querySelector(`.vueDropzone${this.dropZoneId} img`);
  },
  methods: {
    clear() {
      this.$refs[this.dropZoneId].removeAllFiles();
    },
    vDzRemove() {
      // console.log('remove')
    },
    vDzMaxFilesExceeded(file) {
      // Disable exceeding maximum allowed files in VueDropzone
      this.$refs[this.dropZoneId].removeFile(file);
    },
    vDzMaxFilesReached() {
      if (this.$refs[this.dropZoneId].dropzone.files.length < 2) {
        // this.$refs.vueDropzone.enable()
      } else {
        this.$refs[this.dropZoneId].removeFile(
          this.$refs[this.dropZoneId].dropzone.files[0]
        );
      }
    },
    vDzMounted() {},
    getTemplate() {
      return `

                    <div id="template-preview">
                            <div class="dz-preview dz-file-preview well" id="dz-preview-template">
                                    <div class="preview"><img data-dz-thumbnail /></div>
                            </div>
                    </div>
                    `;
    },
    loadImg() {
      if (this.url) {
        this.$refs[this.dropZoneId].removeAllFiles();
        let file = { size: 123, name: "Image", type: "image/*" };
        this.$refs[this.dropZoneId].manuallyAddFile(file, this.url);
      }
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    async uploadFiles(files) {
      this.loading = true;
      try {
        if (!files.length) {
          this.loading = false;
          throw new Error(`No files detected`);
        }
        const uploadedFiles = [];
        for (const file of files) {
          let formObject = new FormData();
          formObject.append("file", file);
          const response = await this.axiosInstance.post(
            this.uploadUrl,
            formObject,
            {
              params: {
                source: "dashboard",
              },
            }
          );

          this.$emit("onImageUpload", {
            url: response.data.url,
            name: response.data.name,
            size: file.size,
          });
          this.$emit("onFileUpload", {
            url: response.data.url,
            name: response.data.name,
            size: file.size,
          });
          uploadedFiles.push({
            url: response.data.url,
            name: response.data.name,
            size: file.size,
          });
          if (uploadedFiles.length === files.length) {
            this.$emit("onUploadComplete", uploadedFiles);
            this.loading = false;
          }
        }
      } catch (err) {
        this.loading = false;
        throw err;
      }
    },
    removeFile() {
      this.$refs[this.dropZoneId].removeAllFiles(true);
      this.$emit("onFileRemove", "");
    },
    async getFileThumb() {
      try {
        const thumbnails = await generatePdfThumbnails(this.url, 400);
        this.fileThumb = thumbnails[0].thumbnail;
        this.fileNumOfPages = thumbnails.length;
      } catch (err) {
        console.error(err);
        this.fileThumb = "";
      }
    },
  },
  computed: {
    axiosInstance() {
      return this.uploadInstance ? this.uploadInstance : this.$http_uploads;
    },
  },
  watch: {
    url(value) {
      if(!value) return; 
      this.loadImg();
      this.validateFileUrlType(this.url);
      this.fileType = this.url.split(".").pop()
        ? this.url.split(".").pop()
        : "undefined";
      if (this.fileType === "pdf") {
        this.getFileThumb();
      }
    },
  },
};
</script>

<style scoped>
.file-uploader-style {
}
</style>
